import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const ItemService = {

  getAllItem: async () => {
    try {
      const response = await axios.get(ENDPOINT.Item);
      return response.data;
    } catch (error) {
      console.error("Error fetching Items:", error.message);
      throw error;
    }
  },

  getItemStats: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Item}/stats`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Item stats:", error.message);
      throw error;
    }
  },

  getDistinctValues: async (field) => {
  try {
    const response = await axios.get(`${ENDPOINT.Item}/distinct/${field}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching distinct values:", error.message);
    throw error;
  }
},

  getLastItem: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Item}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching last Item:", error.message);
      throw error;
    }
  },

  getItemById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Item}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Item:", error.message);
      throw error;
    }
  },

  createItem: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Item, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error creating Item:", error.message);
      throw error;
    }
  },

  updateItem: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Item}/${id}`, data, {
        headers: { "Content-Type": "application/json" },
      });
      return response.data;
    } catch (error) {
      console.error("Error updating Item:", error.message);
      throw error;
    }
  },

  deleteItem: async (id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Item}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting Item:", error.message);
      throw error;
    }
  },
};